import React from 'react';
import { useDispatch } from 'react-redux';

import TennisSelfRatingForm from './TennisSelfRatingForm';
import { postTennisSurveyV2, skipTennisSurveyV2 } from '../../../actions/onboarding-actions';
import { sportTypeIds } from '../../../utils/eventConstants';

import styles from '../nuoV2.scss';

const TennisSelfRating = (props) => {
    const { disableRangeSurveySkip, nuo } = props;
    const { memberSportTypeIds = [] } = nuo.data || {};

    const dispatch = useDispatch();

    const handleSubmit = (values) => {
        const { ageStarted, frequency, matchesCount } = values;
        const payload = { ageStarted, frequency, matchesCount };

        payload.levels = Object.entries(values) // array of levelType ids
            .filter(([key, val]) => key.includes('levelType') && val === true)
            .map(([key]) => key.split('-')[1]);

        dispatch(postTennisSurveyV2(payload));
    };

    const handleSkip = () => {
        dispatch(skipTennisSurveyV2());
    };

    const tennisIsFirst = memberSportTypeIds.indexOf(sportTypeIds.TENNIS) === 0;

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.tennis-self-rating.title">
                {tennisIsFirst && 'Profile created!'} Tell us about your tennis experience to receive an estimated tennis rating (UTR).
            </div>
            {!disableRangeSurveySkip && (
                <div className={`link clickable d-inline mr32`} onClick={handleSkip} data-testid="nuo-v2.tennis-self-rating.skip-link">I&apos;ll do this later.</div>
            )}
            <TennisSelfRatingForm {...props} handleSubmit={handleSubmit} />
        </div>
    );
};

export default TennisSelfRating;
